import { requests } from '../helper/Agent';

export default class Spider {

  static getBrands(vehicleType) {
    return requests.getSpider(`/tipovehiculo/${vehicleType}/marcas`);
  }
  static getModels(vehicleType, id) {
    return requests.getSpider(`/tipovehiculo/${vehicleType}/modelos/${id}`);
  }
  static getChannel() {
    return requests.getSpider('/canales');
  }
}